module.exports = "<div class=hull-captcha-banner-container> <h3 class=hull-banner-title>A lot of users have been created with your IP!</h3> <p class=hull-banner-text>Please prove us that you are a Human.</p> <div class=hull-captcha-container></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./src/utils/ui/captcha.html
// module id = 172
// module chunks = 0